<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Regulaminy</span>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja regulaminu</template>
          <template v-else>Dodawanie regulaminu</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/regulaminy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab title="Dane ogólne" active>
            <h4 class="mb-3 pb-3 border-bottom">
              Regulamin
            </h4>
            <validation-observer ref="regulations-form" tag="form">
              <div class="form-group">
                <label for="name">
                  Nazwa:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="description">
                  Krótki opis:
                </label>
                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.description" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group">
                <label for="filename">
                  Skan dokumentu:
                </label>
                <validation-provider
                  :rules="'required'"
                  :name="'scan'"
                  v-slot="{ errors }">
                  <file-input
                    :state="errors.length ? 'invalid' : null"
                    :class="['form-group', 'mr-2', (importantFile === true && !data.filename) ? 'invalid-file' : '']"
                    :onChange="setImage"
                    :id="'scan'" />
                </validation-provider>
                <div class="invalid-feedback-file" style="display: block;" v-if="importantFile === true && !data.filename">
                  To pole jest wymagane
                </div>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>
            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from '../../utils/FormUtils.js';

export default {
  name: 'regulations-form',
  computed: {
    allDataLoaded () {
      return this.loaded && this.loadedRegulations;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: '',
        name: '',
        filename: '',
        description: '',
      },
      loaded: false,
      loadError: false,
      regulations: [],
      loadedRegulations: false,
      importantFile: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }

    this.loadAdditionalData();
  },
  methods: {
    setImage(event) {
      this.data.filename = event.target.files[0];
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/regulations/item/',
        instanceFields: ['name', 'description', 'filename', 'id'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/services/categories/items',
        params: {
          pagination: false
        },
        outputKey: 'regulations',
        loadedKey: 'loadedRegulations',
        errorKey: 'loadError',
      });
    },
    validateForm () {
      this.importantFile = true
      if (this.data.filename) {
        FormUtils.validate(this.$refs['regulations-form'], this.submitForm);
      } else {
        FormUtils.validate(this.$refs['regulations-form']);
      }
    },
    submitForm () {
      let imageFields = false;
      let formDataToSend = {
        name: this.data.name,
        description: this.data.description,
      };
      if (this.data.filename) {
        formDataToSend.filename = this.data.filename;
        imageFields = ['filename'];
      }
      let endpointUrl = this.isEdit ? '/regulations/update/' + this.id : '/regulations/store';

      FormUtils.submit(this, {
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano regulamin',
        successText: 'Wybrany regulamin został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje regulaminu nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/regulaminy')
        }
      }, imageFields);
    },
  }
}
</script>
<style lang="scss">
  .invalid-file {
    outline: none;
    input, label {
      border-color: #c4183c;
      box-shadow: 0 5px 11.5px rgba(196, 24, 60, 0.1);
      outline: none;
    &:focus {
       outline: none;
     }
    &:active {
       outline: none;
     }
    }
    .mx-icon-calendar {
      color: #c4183c;
    }
  }
  .invalid-feedback-file {
    margin-top: -0.65rem;
    font-size: 80%;
    color: #c4183c;
  }
</style>
